
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBatteryPack100 as ObiBatteryPack100Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-battery-pack-100.js';
 
 
 

 
 export const ObiBatteryPack100 = createComponent({
   react: React,
   tagName: 'obi-battery-pack-100',
   elementClass: ObiBatteryPack100Element,
   events: {
     
   }
  });
 
 